import { render, staticRenderFns } from "./BrainLibraryWidget.vue?vue&type=template&id=060c78a0&scoped=true"
import script from "./BrainLibraryWidget.vue?vue&type=script&lang=js"
export * from "./BrainLibraryWidget.vue?vue&type=script&lang=js"
import style0 from "./BrainLibraryWidget.vue?vue&type=style&index=0&id=060c78a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c78a0",
  null
  
)

export default component.exports